<template>
	<div class="row mt-4">
		<div class="col-12 col-md-4 mb-3">
			<h4>{{ $t('choose-region-or-map') }}</h4>
			<multiselect v-model="selected_items" :options="text_options" :multiple="true"></multiselect>
		</div>
		<div class="col-12 col-md-8">
			<GmapMap :center="centre" :zoom="zoom" style="width: 100%; height: 600px" ref="map" class="box">
				<GmapPolygon v-for="(polygon,index) in polygons" :key="index" :paths="polygon" :editable="false" :clickable="true" :options="polygon_options(index)" @click="polygon_clicked(index)">
				</GmapPolygon>
			</GmapMap>
		</div>
	</div>
</template>

<script>
	import {gmapApi} from 'vue2-google-maps'
	import OpenData from '@/libraries/OpenData'
	import Multiselect from 'vue-multiselect'

	const WINNIPEG_CENTRE = {lat: 49.86, lng: -97.158465};

	export default {
		components: { Multiselect },

		props: ['api_url', 'items', 'column_name'],
		data() {
			return {
				selected_items: [],
				centre: WINNIPEG_CENTRE,
				zoom: 11,
				polygon_default_options: {
					strokeOpacity: 0.5,
					strokeWeight: 1,
					fillOpacity: 0.2,
					fillColor: 'black',
				},
				polygon_clicked_options: {
					fillOpacity: 0.6,
					fillColor: '#2ED9C3',
					strokeWeight: 2,
					strokeOpacity: 1,
				},
				geometry_data: [],
			}
		},

		created() {
			this.selected_items = this.items;
			this.get_items();
		},

		watch: {

			selected_items() {
				this.$emit('choose',this.selected_items);
			}
		},

		computed: {
			polygons() {
				let polygons = [];
				if (this.geometry_data && this.geometry_data.length) {
					polygons = this.geometry_data.map(item => {
						return item[this.column_name].coordinates.map(entry => {
							return entry.reduce((list,polygon) => {
								return list.concat(polygon.map(point => {
									return {
										lat: parseFloat(point[1]), lng: parseFloat(point[0])
									}
								}))
							}, [])
						})
					})
				}
				return polygons;
			},

			text_options() {
				let text_options = [];
				if (this.geometry_data && this.geometry_data.length) {
					text_options = this.geometry_data.map(item => item.name);
				}
				return text_options;
			}
		},

		methods: {
			async get_items() {
				this.geometry_data = await OpenData.getResults(this.api_url,{});
			},

			polygon_options(index) {
				const geometry = this.geometry_data[index];
				if (this.selected_items.includes(geometry.name)) {
					return this.polygon_clicked_options;
				} else {
					return this.polygon_default_options;
				}
			},

			polygon_clicked(index) {
				const geometry = this.geometry_data[index];
				const loc = this.selected_items.indexOf(geometry.name);
				if (loc === -1) {
					this.selected_items.push(geometry.name);
				} else {
					this.selected_items.splice(loc,1);
				}
			},
		},
	}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>

</style>
